/*
 * Filename: field-picklistValueSource-array.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties } from 'mobx-state-tree';


export const FieldPickListData = types.model({
    FieldPickListData: types.optional(types.frozen(), {}),
    selectedPicklistValue: types.optional(types.frozen(), {})
}).actions((self: ModelInstanceTypeProps<ModelProperties>) => ({

    deletePicklistValueSource(objectName: string, deleteRuleObject: any) {
        let existingPicklistObject = { ...self.FieldPickListData };
        delete existingPicklistObject[objectName];
        self.FieldPickListData = existingPicklistObject;

    },
    addPickListValueSource(objectName: string, pickListSource: any) {
            if (self.FieldPickListData.hasOwnProperty(objectName)) {
                const fieldPickListValueSource = { ...self.FieldPickListData };
                delete fieldPickListValueSource[objectName];
                self.FieldPickListData = { ...fieldPickListValueSource, [objectName]: pickListSource[objectName] };
            }
            else {
                let fieldPickListValueSource = { ...self.FieldPickListData };
                fieldPickListValueSource = { ...fieldPickListValueSource, [objectName]: pickListSource[objectName] };
                self.FieldPickListData = fieldPickListValueSource;
            }

    },
    setSelectedPicklistValue(objectName:string){
        if(self.FieldPickListData.hasOwnProperty(objectName)){
            const value = self.FieldPickListData[objectName];
            self.selectedPicklistValue = value;
        } else{
            self.selectedPicklistValue = {}
        }
    },
    setDeployedPicklistData(picklistValues:any){
        self.FieldPickListData = picklistValues;
    }
}));
